// API入口文件
import lrApi from './lrApi';
import yqfApi from './yqfApi';
import biz5xApi from './biz5xApi';

// 导出所有API模块
export default {
  lr_Api: lrApi,//LR接口
	biz5x_Api:biz5xApi,//BIZ 接口
  yqf_Api: yqfApi,//一起飞接口（中间层）  
};